import { render, staticRenderFns } from "./archivedReports.vue?vue&type=template&id=fa8c9122&"
import script from "./archivedReports.vue?vue&type=script&lang=js&"
export * from "./archivedReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports